import React from 'react';

import { Stack, Typography } from '@lyearn/ui';

import { SidebarItemProps } from './types';

function SidebarItem(props: SidebarItemProps) {
  const { item, onClick } = props;

  return (
    <Stack
      alignItems="center"
      className="mb-16 cursor-pointer rounded bg-bg-secondary p-16 hover:bg-bg-hover"
      onClick={() => onClick(item.id)}>
      <Typography color="text-text-paragraph" variant="body-short-02">
        {item?.label}
      </Typography>
    </Stack>
  );
}

export default SidebarItem;
